<template>
  <div v-if="options && options.typeof == '文件上传'" class="video_baseFormBox">
    <div class="baseFormBox_label"><span class="require" v-if="options.require"
        :class="{ requireMsg: formwork[index].options.value }">*</span>{{ options.label }}</div>
    <div class="baseFormBox_label_tip">
      <span>格式要求：{{ formatText }}</span>
      <template v-if="allowVideo">
        <span v-if="options.video_min_time || options.video_max_time">，时长
          <span v-if="options.video_min_time">{{ change_time(options.video_min_time) }}</span>
          <span v-if="options.video_max_time">{{ (options.video_min_time ? '-' : '') +
            change_time(options.video_max_time) }}</span>分钟
        </span>
        <span v-if="options.video_ratio">，长宽比{{ options.video_ratio }}</span>
      </template>
    </div>
    <div class="baseFormBox_data">

      <div :class="{ imgBox: options.fileType.length == 1 && options.fileType[0] == 'typeB' }" class="UQF_item_inp">
        <div v-for="(item, index) in sendForm.videoList" :key="index" v-show="item.isdelate == true"
          class="UQF_videoList_item">

          <!-- 无限制 -->
          <div v-if="options.fileType.length > 1 || options.fileType[0] != 'typeB'">
            <div class="up_name up_ing" v-if="item.status == 1"><span class="name_up">{{ item.name }}</span><span
                class="delateBtn" @click="delateUpload(item, index)">上传中<a-icon type="delete" /></span>
            </div>
            <div class="up_name up_success" v-if="item.status == 2"><span class="name_up">{{ item.name }}</span><span
                class="delateBtn" @click="delateUpload(item, index)">上传成功<a-icon type="delete" /></span>
            </div>
            <div class="up_name up_err" v-if="item.status == 3"><span class="name_up">{{ item.name }}</span><span
                class="delateBtn" @click="delateUpload(item, index)">上传失败<a-icon type="delete" /></span>
            </div>
            <div class="UQF_VIT_botL">
              <div v-if="item.status == 1" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                class="UQF_percent1">
              </div>
              <div v-if="item.status == 2" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                class="UQF_percent2">
              </div>
              <div v-if="item.status == 3" :style="'width:' + Math.round(item.sendMseeage.total.percent) + '%;'"
                class="UQF_percent3">
              </div>
            </div>
          </div>
          <!-- 图片 -->
          <div class="img_list_up" :class="{ img_err: item.status == 3 }"
            v-if="options.fileType.length == 1 && options.fileType[0] == 'typeB'">
            <img v-show="item.status == 2" :id="'op_img' + index" :src="item.url" alt="">
            <img v-show="item.status == 3" src="@/assets/ex_nav.webp" alt="">
            <div class="img_err_icon">
              <div class="img_err_icon_eye"><a-icon type="eye" @click="loadImg('op_img' + index)"
                  :class="{ img_err_noeye: item.status == 3 }" />&nbsp;&nbsp;&nbsp;<a-icon
                  @click="delateUpload(item, index)" type="delete" /></div>
              <div v-show="item.status == 3">上传失败</div>
            </div>
          </div>

        </div>
        <a-upload :multiple="true" v-if="options.fileType.length > 1 || options.fileType[0] != 'typeB'"
          :disabled="isSend" name="file" :customRequest='uploadFn' class="avatar-uploader" :show-upload-list="false"
          :before-upload="beforeUpload" @change="handleChange">
          <a-button v-if="isSend"> <a-icon type="upload" /> 请等待文件上传完毕... </a-button>
          <a-button v-if="!isSend"> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload>
        <a-upload :multiple="true" v-if="options.fileType.length == 1 && options.fileType[0] == 'typeB'"
          :disabled="isSend" name="file" :customRequest='uploadFn' list-type="picture-card"
          class="avatar-uploader img_up_form" :show-upload-list="false" :before-upload="beforeUpload"
          @change="handleChange">
          <img class="upImg" :width='width' :height='height' v-if="imageUrl" :src="imageUrl" alt="file" />
          <div class="up_icon" v-else>
            <a-icon type="plus" />
            <div class="ant-upload-text">
              <span>上传图片</span>
            </div>
          </div>
        </a-upload>
      </div>

    </div>
    <div v-if="showLoading" class="uploadBox">
      <a-icon type="loading" /> 文件上传中...
    </div>
    <slot></slot>
  </div>
</template>

<script>

// import Viewer from "viewerjs";
// import "viewerjs/dist/viewer.css";
// import * as qiniu from 'qiniu-js'
import { uploadTokenApp } from '@/api/upload.js';
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      showLoading: false,
      form: {},
      previewVisible: false,
      previewImage: '',
      fileList: [],
      isSend: false,
      imageUrl: "",
      sendForm: {
        name: '',
        unit: '',
        surgical_name: '',
        video_type: '',
        video_data: '',
        videoList: []
      }
    };
  },
  props: ['options', "index"],
  mounted() {
    // this.loadImg();
  },
  methods: {
    ...mapActions("formwork", ["SET_FORMWORKOBHFUN"]),
    change_time(time) {
      if (time <= 0) {
        return 0
      }
      // 秒转分钟，保留两位小数
      return Number((time / 60).toFixed(2))
    },
    loadImg(id) {
      let _this = this
      if (!document.getElementById(id)) {
        return console.log('无内容');
      }
      setTimeout(() => {
        const ViewerDom = document.getElementById(id);
        console.log('ViewerDom', ViewerDom);
        const viewer = new Viewer(ViewerDom, {
          url: "src",
          navbar: false,
          toolbar: false,
          zIndex: 99999,
          fullscreen: false,
          tooltip: false,
          scalable: false,
          rotatable: false,
          title: function (image) {
            // return image.alt + ' (' + (this.index + 1) + '/' + this.length + ')';
            return "";
          },
        });
        viewer.view();
      }, 200)

    },
    handleChange({ fileList }) {
      // this.fileList = fileList;
      // console.log(this.fileList);
    },
    async sendFn() {
      if (this.isSend) {
        return this.$message.error('请等待文件上传完成！');
      }
      if (!this.sendForm.videoList[0]) {
        return this.$message.error('请上传文件！');
      }
      this.sendForm.video_data = []
      this.sendForm.videoList.forEach(item => {
        if (item.isdelate) {
          this.sendForm.video_data = this.sendForm.video_data + ',' + item.file_id
        }
      });

      for (const key in this.sendForm) {
        if (key != 'videoList') {
          if (this.sendForm[key] == '') {
            this.$message.error('请全部填写完整！');
            return;
          }
        }
      }

      let ok = {
        name: this.sendForm.name,
        unit: this.sendForm.unit,
        surgical_name: this.sendForm.surgical_name,
        video_type: this.sendForm.video_type,
        video_data: this.sendForm.video_data,
      }
      if (this.noResend) {
        return console.log('正在提交，请稍后！')
      }
      this.noResend = true
      let data = await urological2024(ok)
      // this.$message.success('投稿成功！')
      this.noResend = false
      this.$success({
        title: '投稿成功!',
        content: '感谢并请持续关注本次学术大会，手术视频获奖名单可在评审结束后在本页面查看。',
        okText: '确认',
        cancelText: '取消',
      });
      // setTimeout(() => {
      //   history.go(0)
      // }, 2000);
    },
    UQF_typefn(txt) {
      this.sendForm.video_type = txt
      this.UQF_type = txt
    },
    async beforeUpload(file) {
      let _this = this
      let _file = file
      file.sendName = 'subscription_' + Date.now() + file.name.split('.')[0];
      file.isdelate = true;
      let isJpgOrPng = true

      // <!-- 单个文件大小 --> 
      // 将文件大小从兆字节转换为字节
      const maxSizeInBytes = this.options.fileNumber * 1024 * 1024;
      if (file.size >= maxSizeInBytes) {
        this.$message.error(`单个文件大小不能超过 ${this.options.fileNumber}M`);
        file.noSend = true;
        return false;
      }
      // <!-- 文件数量 --> 
      if ((this.fileList.length + 1) > this.options.fileSize) {
        this.$message.error(`最多只能选择 ${this.options.fileSize} 个文件`);
        file.noSend = true;
        return false;
      }
      // <!-- 无限制 --> fileType=='1'
      if (this.options.fileType.includes('typeA') || !this.options.fileType[0]) {
        isJpgOrPng = true;
      } else {
        // typeA 无限制
        // typeB 图片
        // typeC 视频
        // typeD Word
        // typeE Excel
        // typeF PDF 
        let fileTypeMap = {
          typeB: ['image/jpeg', 'image/png', 'image/gif'],
          typeC: ['video/mp4'],
          typeF: ['application/pdf'],
          typeD: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
          typeE: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        };
        // 判断是否符合条件
        if (Array.isArray(this.options.fileType)) {
          // 获取当前允许的文件类型数组
          let allowedTypes = this.options.fileType.reduce((acc, type) => {
            if (fileTypeMap[type]) {
              acc = acc.concat(fileTypeMap[type]); // 合并多个允许的文件类型
            }
            return acc;
          }, []);

          // 检查文件类型是否符合
          let isAllowedType = allowedTypes.includes(file.type);
          if (!isAllowedType) {
            this.$message.error("文件类型不支持！");
            file.noSend = true;
            return false;
          }
        }

      }


      // // <!-- 图片 --> fileType=='2'" 
      // if (this.options.fileType == '2') {
      //   isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      //   if (!isJpgOrPng) {
      //     this.$message.error("仅支持图片上传！");
      //     file.noSend = true;
      //     return false;
      //   }
      // }
      // // <!-- 视频 --> fileType=='3'
      // if (this.options.fileType == '3') {
      //   isJpgOrPng = file.type === "video/mp4";
      //   if (!isJpgOrPng) {
      //     this.$message.error("仅支持mp4视频！");
      //     file.noSend = true;
      //     return false;
      //   }
      // }
      // // <!-- word --> fileType=='4'
      // if (this.options.fileType == '4') {
      //   isJpgOrPng = file.type === "application/pdf" || file.type === "application/msword" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      //   if (!isJpgOrPng) {
      //     this.$message.error("仅支持Pdf或者Word文档！");
      //     file.noSend = true;
      //     return false;
      //   }
      // }
      // // <!-- excel --> fileType=='6'
      // if (this.options.fileType == '5') {
      //   isJpgOrPng = file.type === "application/vnd.ms-excel" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //   if (!isJpgOrPng) {
      //     this.$message.error("仅支持Excel文档！");
      //     file.noSend = true;
      //     return false;
      //   }
      // }


      // <!-- 视频限制：时长、长宽比（管理端配置，仅当允许视频且配置了限制项时生效） -->
      if (file.type === 'video/mp4') {
        const allowVideo =
          (Array.isArray(this.options.fileType) &&
            (this.options.fileType.length === 0 ||
              this.options.fileType.includes('typeA') ||
              this.options.fileType.includes('typeC'))) ||
          this.options.fileType === '' ||
          this.options.fileType === '1' ||
          this.options.fileType === '3';
        const videoMinTime = Number(this.options.video_min_time);
        const videoMaxTime = Number(this.options.video_max_time);
        const videoRatio = this.options.video_ratio ? String(this.options.video_ratio) : '';
        if (allowVideo && (videoMinTime || videoMaxTime || videoRatio)) {
          const videoPass = await this.checkVideoLimit(file, videoMinTime, videoMaxTime, videoRatio);
          if (!videoPass) {
            file.noSend = true;
            return false;
          }
        }
      }

      this.fileList.push(file);

      return true

    },
    checkVideoLimit(file, minTime, maxTime, ratio) {
      return new Promise((resolve) => {
        const videoElement = document.createElement('video'); // 创建 video 元素
        videoElement.preload = 'metadata'; // 只加载元数据
        videoElement.src = URL.createObjectURL(file); // 使用 createObjectURL 加载文件
        // 元数据加载完毕后再校验，避免异步导致判断异常
        videoElement.onloadedmetadata = () => {
          window.URL.revokeObjectURL(videoElement.src); // 释放 URL 对象
          const duration = videoElement.duration; // 视频时长（秒）
          const ratioVal = videoElement.videoWidth / videoElement.videoHeight; // 实际长宽比
          let pass = true;
          if (minTime && duration < minTime) {
            pass = false;
            this.$message.error(`视频时长不能小于 ${this.change_time(minTime)} 分钟`);
          }
          if (pass && maxTime && duration > maxTime) {
            pass = false;
            this.$message.error(`视频时长不能大于 ${this.change_time(maxTime)} 分钟`);
          }
          if (pass && ratio) {
            const targetArr = ratio.split(':');
            const targetAspect = Number(targetArr[0]) / Number(targetArr[1]);
            const tolerance = 0.05; // 容忍误差范围
            if (Math.abs(ratioVal - targetAspect) > tolerance) {
              pass = false;
              this.$message.error(`视频长宽比应为${ratio}！`);
            }
          }
          resolve(pass);
        };
        videoElement.onerror = () => {
          window.URL.revokeObjectURL(videoElement.src);
          resolve(true);
        };
      });
    },

    async uploadFn(file) {
      // 因为获取视频时常和比例是异步操作，会导致判断异常，所以休眠一段时间
      let _this = this
      setTimeout(async () => {

        if (file.file.noSend) {
          return
        }
        let tokenINfo = await uploadTokenApp();
        let token = tokenINfo.payload.uploadToken
        let bucket = tokenINfo.payload.bucket
        let sendFlie = file.file
        // 上传文件
        const config = {
          useCdnDomain: true, // 是否使用 CND 服务器上传
          // region: qiniu.region.z0 // 指定上传区域
        };

        // 年月日时分秒
        const key = `${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}${new Date().getHours()}${new Date().getMinutes()}${new Date().getSeconds()}_${sendFlie.name}`;

        const putExtra = {
          fname: sendFlie.name, // 文件原文件名
          params: {}, // 自定义变量
          mimeType: null, // 上传文件的类型
        };

        // 上传任务
        const observable = qiniu.upload(sendFlie, '0DCF877DF7676AA15558F9A37B13F929', token, putExtra, config);
        // 监听上传过程的事件
        this.showLoading = true
        this[sendFlie.sendName] = observable.subscribe({
          next(res) {
            // // 仅处理上传完成的逻辑
            // if (res.total && res.total.percent < 100) {
            //   console.log(`上传进度: ${res.total.percent}%`);
            //   return; // 忽略未完成的事件
            // }
            _this.isSend = true //打开为同时上传多个
            sendFlie.sendMseeage = res
            sendFlie.status = 1
            sendFlie.url = URL.createObjectURL(sendFlie)
            if (sendFlie.sort) {
              return _this.$set(_this.sendForm.videoList, sendFlie.sort - 1, sendFlie);
            } else {
              _this.sendForm.videoList.push(sendFlie)
            }
            sendFlie.sort = _this.sendForm.videoList.length
          },
          error(err) {
            sendFlie.status = 3
            _this.$message.error('上传失败，请刷新页面重试！');
            _this.$forceUpdate();
            _this.isSend = false
            _this.showLoading = false
            console.log('上传出错:', _this.sendForm);
            console.error('上传出错:', err);
          },
          complete(res) {
            sendFlie.status = 2
            _this.isSend = false
            sendFlie.file_id = res.payload.file_id
            sendFlie.file_url = res.payload.file_url
            _this.options.value = []
            _this.fileList.forEach((item, index) => {
              if (item.isdelate) {
                _this.options.value.push({ file_id: item.file_id, name: item.name, file_url: item.file_url, type: sendFlie.type })
              }
            });
            _this.showLoading = false
            console.log('上传完成:', _this.sendForm);
            _this.$forceUpdate();
          }
        });

      }, 500);
    },
    delateUpload(subscription, index) {
      // this.sendForm.videoList.splice(index, 1);
      this.sendForm.videoList[index].isdelate = false
      this.fileList = this.fileList.filter(item => item.sendName !== subscription.sendName);

      console.log(subscription, index)
      console.log(this.fileList)

      this.$forceUpdate();

    },
    cancelUpload(subscription, index) {
      console.log(subscription.sendName, index)
      console.log(this.sendForm.videoList, index)
      if (subscription && subscription.sendName && this[subscription.sendName]) {
        this[subscription.sendName].unsubscribe()
        setTimeout(() => {
          this.isSend = false
          // this.sendForm.videoList.splice(index, 1);
          this.sendForm.videoList[index].isdelate = false
          this.$forceUpdate();
          this.$message.info('上传已取消');
        }, 500);
      } else {
        this.$message.error('取消失败，请刷新页面重试！')
      }
    },

  },
  computed: {
    ...mapGetters(["formwork"]),
    // options() {
    //   let data = this.formwork[this.index] ? this.formwork[this.index].options : {};
    //   if (data.value && data.value[0]) {
    //     data.value.forEach(item => {
    //       // 检查是否已经存在该文件，避免重复添加
    //       if (!this.sendForm.videoList.some(video => video.file_id === item.file_id)) {
    //         this.sendForm.videoList.push({
    //           name: item.name,
    //           file_id: item.file_id,
    //           status: 2,
    //           isdelate: true,
    //           type: item.type,
    //           file_url: item.file_url,
    //           sendMseeage: {
    //             total: {
    //               "size": 101691,
    //               "loaded": 101691,
    //               "percent": 100
    //             }
    //           }
    //         });
    //       }
    //     });
    //   }
    //   console.log(data);
    //   console.log(this.sendForm.videoList);
    //   return data;
    // },

    // 归一化文件类型为数组，兼容旧版字符串类型
    fileTypeList() {
      const fileType = this.options && this.options.fileType;
      if (Array.isArray(fileType)) return fileType;
      if (fileType === undefined || fileType === null || fileType === '') return [];
      return [String(fileType)];
    },
    // 是否允许上传视频（无限制或勾选了视频）
    allowVideo() {
      const list = this.fileTypeList;
      return (
        list.length === 0 ||
        list.includes('typeA') ||
        list.includes('typeC') ||
        list.includes('1') ||
        list.includes('3')
      );
    },
    // 依据所选文件类型生成格式要求文案
    formatText() {
      const list = this.fileTypeList;
      if (list.length === 0 || list.includes('typeA') || list.includes('1')) {
        return '无限制';
      }
      const typeMap = {
        typeB: '图片(JPG/PNG/GIF)',
        typeC: '视频(MP4)',
        typeD: 'Word',
        typeE: 'Excel',
        typeF: 'PDF',
        '2': '图片(JPG/PNG/GIF)',
        '3': '视频(MP4)',
        '4': 'PDF/Word',
        '5': 'Excel'
      };
      const result = [];
      list.forEach(type => {
        const text = typeMap[type];
        if (text && !result.includes(text)) {
          result.push(text);
        }
      });
      return result.length ? result.join('、') : '无限制';
    },

    optionRules: {
      get() {
        let ruleArray = [];
        if (this.options.require) {
          ruleArray.splice(0, 0, {
            required: true,
            message: this.options.requireMsg
              ? this.options.requireMsg
              : "该内容不能为空",
            trigger: "change"
          });
        }
        return ruleArray;
      }
    },
  },
};
</script>
<style lang="less">
.video_baseFormBox .ant-upload {
  min-height: unset;
}

.baseFormBox_label_tip {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #919499;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  margin-bottom: 8px;
}

.uploadBox {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.imgBox {
  display: flex;
  flex-wrap: wrap;

  .ant-upload-picture-card-wrapper {
    width: unset;
  }

  .UQF_videoList_item {
    margin-bottom: 12px;
    margin-right: 12px;
  }
}

.img_list_up {
  position: relative;
  width: 104px;
  height: 104px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;

  img {
    width: 100%;
    height: 100%;
  }
}

.img_err {
  border: 1px solid #dd2e2e;
}

.img_err_icon_eye {
  margin-bottom: 4px;
}

.img_err_icon {
  position: absolute;
  width: 88px;
  height: 88px;
  background-color: rgba(0, 0, 0, 0.3);
  top: 8px;
  right: 0px;
  bottom: 0;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #d9d9d9;
}

.img_err_noeye {
  color: #b4b7bd;
}

.UQF_item_inp {
  width: 100%;
}

.name_up {
  flex: 1;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: calc(100% - 100px);
  margin-right: 12px;
}

.delateBtn {
  width: 100px;
  text-align: right;
  cursor: pointer;

  i {
    margin-left: 12px;
  }
}

.up_name {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.up_ing {
  color: #f7ba5d;
}

.up_success {
  color: #45b841;
}

.up_err {
  color: #dd2e2e;
}

.UQF_VIT_botL {
  width: 100%;
}

.UQF_videoList_item {
  margin-bottom: 20px;
}

.UQF_VIT_botr {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  img {
    margin-right: 4px;
  }

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    font-style: normal;
  }
}

.UQF_VIT_botrT {
  color: #919499;
}

.UQF_VIT_botrC {
  color: #45b841;
}

.UQF_VIT_botrB {
  color: #dd2e2e;
}

.UQF_percent {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #919499;
  line-height: 17px;
  text-align: center;
  font-style: normal;
}

.UQF_VIT_botL {
  height: 6px;
  background: #f5f6fa;
  border-radius: 3px;
  margin-right: 6px;
  position: relative;
}

.UQF_percent1 {
  background: #f7ba5d;
  height: 100%;
  width: 30%;
  border-radius: 3px;
  position: absolute;
}

.UQF_percent2 {
  background: #45b841;
  height: 100%;
  width: 40%;
  border-radius: 3px;
  position: absolute;
}

.UQF_percent3 {
  background: #dd2e2e;
  height: 100%;
  width: 50%;
  border-radius: 3px;
  position: absolute;
}
</style>
<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.img_up_form {
  width: 104px !important;
  height: 104px;
}
</style>